<template>
    <div class="thanks-for-application">
        <h5 class="thanks-for-application__title">{{ result.title }}</h5>
        <p class="thanks-for-application__text">{{ result.text }}</p>
        <button
            type="button"
            class="def-button"
            @click="$DefModal.hide()"
        >{{ messages.ok }}</button>
    </div>
</template>

<script>
export default {
    name: 'thanks-for-application',
    selector: '.thanks-for-application',
    props: {
        result: {
            type: Object,
        },
        messages: {
            type: Object,
            default: {
                ok: 'OK',
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.thanks-for-application{
    text-align: center;
    &__title{
        font-weight: 500;
        font-size: rem(18);
        line-height: 110%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        color: #191918;
        margin-bottom: 24px;
    }
    &__text{
        font-weight: 500;
        font-size: rem(16);
        line-height: 110%;
        color: #191918;
        margin-bottom: 32px;
    }
    .def-button{
        display: flex;
        width: 100%;
        font-weight: 500;
        font-size: rem(14);
        line-height: 115%;
        letter-spacing: 0.08em;
        text-transform: uppercase;
    }
}
</style>